import { rest } from "src/common/rest";
import { restWithObjectVersion } from "src/common/restWithObjectVersion";
import { apiObjUrl } from "src/common/apiUrl";
import { zServiceInfo, ZServiceInfo } from "src/types/ZServiceInfo";
import { makeDictionary } from "src/common/makeDictionary";
import { ZUid } from "src/types/zUid";
import {
  ObjectServiceExt,
  zObjectService,
  ZObjectService,
} from "./businessServises.types";

export const loadServicesList = async (): Promise<ZServiceInfo[]> => {
  if (servCache) return servCache;
  const resp = await restWithObjectVersion.get(apiObjUrl("/business-services"));
  const list = zServiceInfo.array().parse(resp.data);
  servCache = list;
  return list;
};
let servCache: ZServiceInfo[] | null = null;

const loadServicesFor = async (
  url: string,
  options: {
    translate?: boolean;
  } = {},
): Promise<ObjectServiceExt[]> => {
  const resp = await restWithObjectVersion.get(apiObjUrl(url), {
    translate: options.translate,
  });
  const raw = zObjectService.array().parse(resp.data);
  const list = await loadServicesList();
  const dict = makeDictionary(list, ({ id }) => id);
  const result: ObjectServiceExt[] = [];
  raw.forEach((src) => {
    const def = dict[src.serviceId];
    if (def) {
      result.push({
        ...src,
        serviceKey: def.name,
      });
    }
  });
  return result;
};

export const loadServicesForObject = async (
  objectId: ZUid,
  options: {
    translate?: boolean;
  } = {},
): Promise<ObjectServiceExt[]> =>
  loadServicesFor(`/business-services/${objectId}/services`, options);

export const loadServicesForEntity = async (
  objectId: ZUid,
  entityId: ZUid,
  options: {
    translate?: boolean;
  } = {},
): Promise<ObjectServiceExt[]> =>
  // TODO: На момент коммита промежуточной версии перехода на uid, этот запрос для v2 не возвращал инф. о лейблах. В результате не выводился заголовок страницы
  loadServicesFor(
    `/business-services/${objectId}/${entityId}/services`,
    options,
  );

export const createServiceForObject = async (
  data: Omit<ZObjectService, "id">,
): Promise<ZObjectService> => {
  const resp = await rest.post(apiObjUrl("/business-services"), data);
  return zObjectService.parse(resp.data);
};

export const deleteServiceForObject = async ({
  objectId,
  serviceId,
}: ZObjectService): Promise<void> => {
  await rest.delete(apiObjUrl("/business-services"), {
    params: {
      objectId,
      serviceId,
    },
  });
};
